<div class="wrapper"
     [style.height]="height"
     [style.width]="width">
  <ng-content></ng-content>
</div>
<div (click)="closeClick($event)" class="backdrop"></div>
